/* How a merchandiser gets around, as a label.
 *
 * ⚠ The option VALUES and their lang keys do not match, and cannot be made to: `bike/scooter`
 * carries a slash. Deriving the key from the value therefore needs a map, and the two call sites
 * that tried to derive it inline instead — `mv_${value}` with a hand-patch for the slash — asked
 * for `mv_public_transport`, which does not exist. `translate()` returned null, so one site fell
 * back to `MOVEMENTS_OPT`'s hardcoded English "Public transport" in ALL FOUR locales and the other
 * two rendered blank (PICSELL-1574 #6). The map lives here so a new movement is one edit, not four.
 *
 * Its own module rather than `MerchList.js` (where a copy of it lived) so the list's stylesheet and
 * deps are not dragged into the detail page's bundle.
 */
import { MERCH_LIST } from "../../config/lang";
import { translate } from "../../util/util";

const MOVEMENT_LANG_KEY = {
  "on_foot": "mv_on_foot",
  "motorcycle": "mv_motorcycle",
  "bike/scooter": "mv_bike",
  "automobile": "mv_automobile",
  "public_transport": "mv_public",
};

/** Falls back to the raw value, never to English: `public_transport` reads as untranslated, where
 *  "Public transport" reads as a translation and hid this bug for a release. */
export const movementLabel = (value, lang) => {
  const key = MOVEMENT_LANG_KEY[value];
  return (key && translate(MERCH_LIST, key, lang)) || value || "";
};
